import type {IconButtonProps} from '@mui/material'
import {IconButton} from '@mui/material'
import {Link as RouterLink} from 'react-router-dom'
import {useCourseContext} from '@goschool/dao'
import {Authorize} from '@goschool/auth'
import type {SvgIconComponent} from '@mui/icons-material'
import type {GoSchoolUserRole} from '@goschool/model'


interface CourseActionLinkProps extends Omit<IconButtonProps, 'size'> {
  to: string,
  Icon: SvgIconComponent
  roles: GoSchoolUserRole[]
}

export function CourseActionLink({to, Icon, roles, ...buttonProps}: CourseActionLinkProps) {
  const {courseRoles} = useCourseContext()
  return <Authorize roles={roles} contextRoles={courseRoles}>
    <IconButton size="small" component={RouterLink} to={to} {...buttonProps}>
      <Icon sx={{fontSize: '16px'}}/>
    </IconButton>
  </Authorize>
}

type InstructorActionLinkProps = Omit<CourseActionLinkProps, 'roles'>

export function InstructorActionLink({to, Icon, ...buttonProps}: InstructorActionLinkProps) {
  return <CourseActionLink to={to} Icon={Icon} roles={['instructor']} {...buttonProps}/>
}

type StudentActionLinkProps = Omit<CourseActionLinkProps, 'roles'>

export function StudentActionLink({to, Icon, ...buttonProps}: StudentActionLinkProps) {
  return <CourseActionLink to={to} Icon={Icon} roles={['student']} {...buttonProps}/>
}
